<template>
  <div :class="style.landingEditor">
    <SettingPanelComponent @close-panel="closePanel" />

    <LandingPreviewFrame
      :version="selectedVersion"
      :is-loading="isQuizLoading"
      :main-style="previewMainStyle"
      @main-scroll="handleMainScroll"
    >
      <LandingMobileContent
        v-if="isMobileVersion"
        :isUpdateRef="isUpdateRef"
        @completeUpdateRef="isUpdateRef = false"
      />
      <LandingDesktopContent
        v-else
        :isUpdateRef="isUpdateRef"
        @completeUpdateRef="isUpdateRef = false"
      />
    </LandingPreviewFrame>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

import style from "./LandingPage.module.scss";

import {VersionType} from "../../typeQuiz";

import LandingPreviewFrame from "./components/layout/LandingPreviewFrame.vue";
import LandingDesktopContent from "./components/layout/LandingDesktopContent.vue";
import LandingMobileContent from "./components/layout/LandingMobileContent.vue";
import SettingPanelComponent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/SettingPanelComponent.vue";

export default defineComponent({
  name: "LandingPage",

  components: {
    SettingPanelComponent,
    LandingPreviewFrame,
    LandingDesktopContent,
    LandingMobileContent
  },

  data() {
    return {
      style,
      isUpdateRef: false,
      dataIsLoaded: false,
      dataLoadedTimerId: 0
    };
  },

  mounted() {
    this.startDataLoadedTimer();
  },

  beforeUnmount() {
    this.clearDataLoadedTimer();
  },

  methods: {
    closePanel(): void {
      this.$panelStore.closeSettingPanel();
    },

    updateRightRef(): void {
      this.isUpdateRef = true;
    },

    startDataLoadedTimer(): void {
      this.clearDataLoadedTimer();
      this.dataIsLoaded = false;

      this.dataLoadedTimerId = window.setTimeout(() => {
        this.dataIsLoaded = true;
      }, 700);
    },

    clearDataLoadedTimer(): void {
      if (!this.dataLoadedTimerId) {
        return;
      }

      window.clearTimeout(this.dataLoadedTimerId);
      this.dataLoadedTimerId = 0;
    },

    handleMainScroll(event: Event): void {
      const main = event.target as HTMLElement | null;

      if (!main) {
        return;
      }

      this.keepScrollInsidePreview(main);
    },

    keepScrollInsidePreview(main: HTMLElement): void {
      const lastChild = main.children[main.children.length - 1] as
        | HTMLElement
        | undefined;

      if (!lastChild) {
        return;
      }

      const coordinates = lastChild.getBoundingClientRect();
      const endPoint = coordinates.top - (window.innerHeight / 100) * 50;

      if (endPoint < 0) {
        main.scrollTo(0, main.scrollHeight + 10 - window.innerHeight * 1.6);
      }
    }
  },

  computed: {
    selectedVersion(): VersionType {
      return this.$quizStore.getSelectedVersion;
    },

    isMobileVersion(): boolean {
      return this.selectedVersion === "Мобильная";
    },

    quiz() {
      return this.$quizStore.getQuiz;
    },

    isQuizLoading(): boolean {
      return !this.quiz || this.quiz._id === "";
    },

    selectedQuestion(): number {
      return this.$quizStore.getSelectedQuestion;
    },

    previewMainStyle(): Record<string, string> {
      return {
        overflow:
          this.selectedQuestion !== -1 || !this.dataIsLoaded ? "hidden" : "auto"
      };
    }
  },

  watch: {
    selectedVersion(): void {
      this.startDataLoadedTimer();

      if (this.quiz?.onlyFormBool) {
        return;
      }

      window.scrollTo({top: 0});
    },

    selectedQuestion(): void {
      this.startDataLoadedTimer();
    }
  }
});
</script>
